// src/pages/taxonomy/OrderCategories/OrderCategoriesFormPage.jsx
import React, { useEffect, useState } from 'react'
import { useParams, useHistory, Link } from 'react-router-dom'
import { OrderCategoriesAPI } from '../../../api/v3/taxonomy-api-v3'

const BASE = '/app/sales/bagspa/taxonomy'

export default function OrderCategoriesFormPage() {
  const { id } = useParams()
  const history = useHistory()
  const isEdit = Boolean(id)

  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [category, setCategory] = useState('')
  const [size, setSize] = useState('')
  const [material, setMaterial] = useState('')
  const [basePrice, setBasePrice] = useState('')
  const [isActive, setIsActive] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    async function load() {
      if (!isEdit) return
      try {
        setLoading(true)
        const payload = await OrderCategoriesAPI.show(id)
        const item = payload?.item ?? payload?.data ?? payload ?? {}
        setName(item?.name || '')
        setCode(item?.code || '')
        setCategory(item?.category || '')
        setSize(item?.size || '')
        setMaterial(item?.material || '')
        setBasePrice(item?.base_price || '')
        setIsActive(Boolean(item?.is_active))
      } catch (e) {
        setError(e.message)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [id, isEdit])

  async function handleSubmit(e) {
    e.preventDefault()
    try {
      setLoading(true)
      const payload = {
        name,
        code,
        category,
        size,
        material,
        base_price: parseFloat(basePrice) || 0,
        is_active: isActive,
      }
      if (isEdit) {
        await OrderCategoriesAPI.update(id, payload)
      } else {
        await OrderCategoriesAPI.create(payload)
      }
      history.push(`${BASE}/order_categories`)
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{isEdit ? 'Edit' : 'New'} Order Category</h3>
        <Link to={`${BASE}/order_categories`}>&larr; Back</Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input className="form-control" value={name} onChange={e => setName(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Code</label>
          <input
            className="form-control"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            placeholder="e.g., FT, CL, RC"
            required
          />
        </div>

        <div className="form-group">
          <label>Category</label>
          <input className="form-control" value={category} onChange={e => setCategory(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Size</label>
          <input className="form-control" value={size} onChange={e => setSize(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Material</label>
          <input className="form-control" value={material} onChange={e => setMaterial(e.target.value)} />
        </div>

        <div className="form-group">
          <label>Base Price / Fare (Rp)</label>
          <input
            type="number"
            className="form-control"
            value={basePrice}
            onChange={e => setBasePrice(e.target.value)}
          />
        </div>

        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="isActive"
            checked={isActive}
            onChange={e => setIsActive(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isActive">
            Active
          </label>
        </div>

        <button className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  )
}
